import {Component} from 'react';
import {ReactModal} from '../../components/modals/ReactModal';
import {buildActions} from './actions';
import {ReactReduxModalHOC} from './components/ReactReduxModalHOC';
import {ReactReduxModalEpics} from './epics';
import {buildReducer} from './reducers';
import {validateOptions} from './utils';


/**
 * @param {ReactReduxModalOptions} options
 * @constructor
 */
export function ReactReduxModal(options) {
  validateOptions(options);

  this.options = options;
  this.actions = buildActions(options);
  this.reducers = buildReducer(this.actions, options);
  this.epics = new ReactReduxModalEpics(this.actions, options);

  if (this.options.modalComponent) {
    this.modalComponent = ReactReduxModalHOC(this.options.modalComponent, this.options, ReactModal);
    this.options.modalComponent = this.modalComponent;
  }
}

export function getIsShowingModal(modalState) {
  return modalState.isShowingModal;
}

/**
 * @typedef {Object} ReactReduxModalOptions
 * @property {String} prefix
 * @property {Function} getState
 * @property {Logger} logger
 * @property {Component} [modalComponent] The react component to render in a modal
 * @property {ModalOptions} [modalOptions] Options passed to modal manager
 * @property {ReduxAction} [onSuccessAction] Dispatched with the successful result as the payload
 * @property {ReduxAction} [onErrorAction] Dispatched with the successful result as the payload
 * @property {Object} [initialState={}] Provide additional initial state properties.
 */



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-redux-modals/index.js